import LyTaocanPrice from './src/index.vue'

LyTaocanPrice.install = function (Vue) {
    Vue.component(LyTaocanPrice.name, LyTaocanPrice)
}

export default LyTaocanPrice



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/taocan-price/index.js
// module id = null
// module chunks = 